import { STORE_USER_AUTH } from '@core/local-storage/local-storage';
import { AccountType } from '@core/models/account/account-type';
import { AuthSession } from '@core/models/auth/auth-session';
import { AuthTokenType } from '@core/models/auth/auth-token-type';
import { environment } from '@environments/environment';

export interface IAuthState {
    company: AuthSession;
    user: AuthSession;
    version: string;
}

export const initialState: IAuthState = {
    company: {
        access_token: '',
        refresh_token: '',
        token_type: AuthTokenType.BEARER,
        expires_in: 0,
        _profile_type: AccountType.COMPANY,
        _profile_id: '',
    },
    user: {
        access_token: '',
        refresh_token: '',
        token_type: AuthTokenType.BEARER,
        expires_in: 0,
        _profile_type: AccountType.USER,
        _profile_id: '',
    },
    version: '-2',
};

/**
 * Init state method passed into the store feature module.
 * Attempts to recover auth from local storage and injects latest build version.
 */
export function initialAuthState() {
    let w: any = window;
    let auth = { ...initialState };
    try {
        const authorisationSet: any = JSON.parse(
            w.localStorage.getItem(
                `${ environment.settings.localStoragePrefix }.${ STORE_USER_AUTH }`
            )
        );
 
        auth = {
            ...auth,
            ...authorisationSet
        };

    } catch (e) {}
    auth['version'] = w.IHD && w.IHD.version;

    return auth;
}